document.addEventListener("DOMContentLoaded", function () {
  console.log("-fl4v10-");

  //SLIDER ARTICOLO
  $(".article-template__product-carousel .slider").each(function () {
    var classList = this.className;
    var desktopMatch = classList.match(/grid--(\d+)-col-desktop/);
    var tabletMatch = classList.match(/grid--(\d+)-col-tablet(?:-down)?\b/);

    var slidesDesktop = desktopMatch ? parseInt(desktopMatch[1], 10) : 1;
    var slidesTablet = tabletMatch
      ? parseInt(tabletMatch[1], 10)
      : Math.min(slidesDesktop, 2);

    $(this).slick({
      slidesToShow: slidesDesktop,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 1000,
      cssEase: "cubic-bezier(1.00,-0.10,0.47,1.01)",
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: slidesTablet,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  //SLIDER COLLECTION LIST + PRODUCT LIST
  $(
    ".off_collection_list.off_product_list slider-component .collection-list",
  ).each(function () {
    if ($(this).hasClass("slick-initialized")) return;

    $(this).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M21 12L3 12M3 12L11.5 3.5M3 12L11.5 20.5" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M3 12L21 12M21 12L12.5 3.5M21 12L12.5 20.5" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
      dots: false,
      infinite: true,
      autoplay: false,
      speed: 1000,
      cssEase: "cubic-bezier(1.00,-0.10,0.47,1.01)",
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  //SLIDER FULL WIDTH SECTION
  $(".section_slide_full_width .slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    cssEase: "cubic-bezier(1.00,-0.10,0.47,1.01)",
  });

  //SLIDER PRODUCT
  if (window.innerWidth < 1281) {
    $(".product__media-wrapper .product__media-list").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1000,
      cssEase: "cubic-bezier(1.00,-0.10,0.47,1.01)",
    });
  }

  //DRAG'N'DROP SCROLL COLLECTION LIST (solo sopra i 1280px)
  // L'elemento che scrolla davvero e' <slider-component>, non la <ul>:
  // l'overflow e' su .slider-mobile-gutter (off_blocks.scss).
  (function () {
    var SELECTOR =
      ".off_collection_list:not(.off_product_list) slider-component.slider-mobile-gutter";
    var mq = window.matchMedia("(min-width: 1281px)");
    var DRAG_THRESHOLD = 5; // px oltre i quali il rilascio non e' piu' un click

    function sync() {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        el.classList.toggle("dragscroll", mq.matches);
        el.classList.toggle("is-draggable", mq.matches);
      });
      if (window.dragscroll) window.dragscroll.reset();
    }

    // Dopo un trascinamento il link della card sotto al cursore non deve aprirsi
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      var startX = 0;
      var startY = 0;
      var dragged = false;

      el.addEventListener("mousedown", function (e) {
        startX = e.clientX;
        startY = e.clientY;
        dragged = false;
      });

      el.addEventListener("mousemove", function (e) {
        if (e.buttons !== 1) return;
        if (
          Math.abs(e.clientX - startX) > DRAG_THRESHOLD ||
          Math.abs(e.clientY - startY) > DRAG_THRESHOLD
        ) {
          dragged = true;
        }
      });

      // capture: intercetta prima che il link navighi
      el.addEventListener(
        "click",
        function (e) {
          if (!dragged) return;
          e.preventDefault();
          e.stopPropagation();
        },
        true,
      );
    });

    sync();
    if (mq.addEventListener) {
      mq.addEventListener("change", sync);
    } else {
      mq.addListener(sync); // Safari < 14
    }
  })();

  //MENU DESKTOP ALL'HOVER (solo sopra i 1280px, dove compare il menu inline)
  (function () {
    var mq = window.matchMedia("(min-width: 1281px)");
    var CLOSE_DELAY = 120; // ms: evita la chiusura sul passaggio diagonale summary -> pannello
    var items = document.querySelectorAll(".header__inline-menu details");

    function open(details) {
      if (details.open) return;
      details.open = true;
      var summary = details.querySelector("summary");
      if (summary) summary.setAttribute("aria-expanded", "true");
    }

    function close(details) {
      // Usa l'API del custom element di Dawn: toglie open e allinea aria-expanded
      var host = details.closest("header-menu, details-disclosure");
      if (host && typeof host.close === "function") {
        host.close();
      } else {
        details.open = false;
      }
    }

    items.forEach(function (details) {
      var timer = null;

      details.addEventListener("mouseenter", function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        items.forEach(function (other) {
          if (other !== details && other.open) close(other);
        });
        open(details);
      });

      details.addEventListener("mouseleave", function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          close(details);
        }, CLOSE_DELAY);
      });

      // Con il trigger sull'hover, il click sul summary richiuderebbe il menu
      // sotto al cursore. Il summary contiene uno <span>, non un link: non si perde niente.
      var summary = details.querySelector("summary");
      if (summary) {
        summary.addEventListener("click", function (e) {
          if (mq.matches) e.preventDefault();
        });
      }
    });

    // Scendendo sotto la soglia non deve restare niente aperto
    function onChange() {
      if (mq.matches) return;
      items.forEach(function (d) {
        if (d.open) close(d);
      });
    }
    if (mq.addEventListener) {
      mq.addEventListener("change", onChange);
    } else {
      mq.addListener(onChange); // Safari < 14
    }
  })();

  //PHOTOSWIPE
  var pswpLightbox = null;
  function initPhotoSwipe() {
    if (typeof PhotoSwipeLightbox === "undefined") return;
    if (pswpLightbox) pswpLightbox.destroy();

    pswpLightbox = new PhotoSwipeLightbox({
      gallery: ".product__media-list",
      children:
        '.product__media-item:not([style*="display: none"]) .pswp-gallery__item',
      pswpModule: PhotoSwipe,
      bgOpacity: 0.9,
      padding: { top: 30, bottom: 30, left: 0, right: 0 },
      showHideAnimationType: "fade",
      showAnimationDuration: 300,
      hideAnimationDuration: 300,
    });
    pswpLightbox.init();
  }
  //initPhotoSwipe();

  //PRODUCT IMAGE FILTER by variant
  (function () {
    var gallery = document.querySelector(".product__media-list");
    if (!gallery) return;

    var items = Array.from(gallery.querySelectorAll(".product__media-item"));
    if (!items.length) return;

    // Fix anti-salto pagina al cambio variante.
    // Gli item in fade-out (opacity:0) devono lasciare SUBITO il flusso
    // (display:none): altrimenti restano "alti" per FADE_MS mentre i nuovi
    // item entrano, la galleria si gonfia (es. 736->1472->736) e la pagina
    // salta. Regola dichiarativa = collasso nell'istante in cui opacity diventa
    // 0, prima di ogni paint. Validato sul sito live: delta scroll 162px -> 0px.
    if (!document.getElementById("off-media-filter-style")) {
      var _mfStyle = document.createElement("style");
      _mfStyle.id = "off-media-filter-style";
      _mfStyle.textContent =
        '.product__media-list .product__media-item[style*="opacity: 0"]{display:none!important;}';
      document.head.appendChild(_mfStyle);
    }

    function getActiveCode(attr) {
      var labels = document.querySelectorAll(
        "variant-selects label[" + attr + "]",
      );
      for (var i = 0; i < labels.length; i++) {
        var input = document.getElementById(labels[i].getAttribute("for"));
        if (input && input.checked) {
          return labels[i].getAttribute(attr);
        }
      }
      return null;
    }

    function getAllCodes(attr) {
      var labels = document.querySelectorAll(
        "variant-selects label[" + attr + "]",
      );
      var codes = [];
      for (var i = 0; i < labels.length; i++) {
        var c = labels[i].getAttribute(attr);
        if (c && codes.indexOf(c) === -1) codes.push(c);
      }
      return codes;
    }

    function srcCarriesAnyCode(src, codes) {
      for (var i = 0; i < codes.length; i++) {
        if (src.indexOf(codes[i]) !== -1) return true;
      }
      return false;
    }

    var FADE_MS = 350;

    function filterImages() {
      var color = getActiveCode("data-color");
      var pietra = getActiveCode("data-pietra");
      var allColors = getAllCodes("data-color");
      var allPietre = getAllCodes("data-pietra");

      items.forEach(function (item) {
        var img = item.querySelector("img");
        if (!img) {
          item.style.display = "none";
          return;
        }
        var src = img.getAttribute("src") || "";

        var show = true;
        // Filtro colore-oro applicato solo se l'immagine porta un codice colore (anche diverso dall'attivo)
        if (
          color &&
          srcCarriesAnyCode(src, allColors) &&
          src.indexOf(color) === -1
        )
          show = false;
        // Filtro pietra applicato solo se l'immagine porta un codice pietra
        if (
          pietra &&
          srcCarriesAnyCode(src, allPietre) &&
          src.indexOf(pietra) === -1
        )
          show = false;

        // Cancella eventuale collapse in coda da una transizione precedente
        if (item._fadeTimer) {
          clearTimeout(item._fadeTimer);
          item._fadeTimer = null;
        }
        item.style.transition = "opacity " + FADE_MS + "ms ease";

        if (show) {
          if (item.style.display === "none") {
            // Riapri a opacity 0 → al frame successivo anima a 1
            item.style.display = "";
            item.style.opacity = "0";
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                item.style.opacity = "1";
              });
            });
          } else {
            item.style.opacity = "1";
          }
        } else if (item.style.display !== "none") {
          item.style.opacity = "0";
          item._fadeTimer = setTimeout(function () {
            item.style.display = "none";
            item._fadeTimer = null;
          }, FADE_MS);
        }
      });

      // Reinit PhotoSwipe a fade completato, così la lightbox include
      // solo le immagini effettivamente rimaste visibili (display:none collassato)
      setTimeout(initPhotoSwipe, FADE_MS + 20);
    }

    // Filter on page load
    filterImages();

    // Re-filter after Dawn finishes re-rendering the variant picker
    if (
      typeof subscribe !== "undefined" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      subscribe(PUB_SUB_EVENTS.variantChange, filterImages);
    }
  })();

  //PRODUCT SKU update on variant change
  (function () {
    var skuEl = document.querySelector("[data-product-sku]");
    if (!skuEl) return;
    if (
      typeof subscribe === "undefined" ||
      typeof PUB_SUB_EVENTS === "undefined"
    )
      return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      skuEl.textContent = variant.sku || "";
    });
  })();

  //PRODUCT PIETRA name update on variant change
  (function () {
    var el = document.querySelector("[data-pietra-name]");
    if (!el) return;
    var pos = el.getAttribute("data-pietra-option-position");
    if (!pos) return;
    if (
      typeof subscribe === "undefined" ||
      typeof PUB_SUB_EVENTS === "undefined"
    )
      return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      var name = variant["option" + pos];
      if (name) el.textContent = name;
    });
  })();

  //PRODUCT CARATURA update on variant change
  // Caratura è un metafield a livello variante: non è presente nell'oggetto
  // variant dell'evento variantChange, quindi leggiamo da una mappa id→valore
  // renderizzata da Liquid.
  (function () {
    var valEl = document.querySelector("[data-caratura-value]");
    var rowEl = document.querySelector("[data-caratura-row]");
    var mapEl = document.querySelector("[data-caratura-map]");
    if (!valEl || !rowEl || !mapEl) return;
    if (
      typeof subscribe === "undefined" ||
      typeof PUB_SUB_EVENTS === "undefined"
    )
      return;

    var map = {};
    try {
      map = JSON.parse(mapEl.textContent || "{}");
    } catch (e) {
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      var val = map[String(variant.id)];
      if (val) {
        // "ct" solo se il valore non è un intervallo/placeholder con "-"
        // (stessa regola del render Liquid iniziale)
        valEl.textContent = val.indexOf("-") === -1 ? val + "ct" : val;
        rowEl.hidden = false;
      } else {
        valEl.textContent = "";
        rowEl.hidden = true;
      }
    });
  })();

  //FACETS: hide filter options whose label contains "NONE"
  (function () {
    function hideNoneOptions() {
      document
        .querySelectorAll(
          ".list-menu__item.facets__item .facet-checkbox__text-label",
        )
        .forEach(function (label) {
          if ((label.textContent || "").toUpperCase().indexOf("NONE") === -1)
            return;
          var item = label.closest(".list-menu__item.facets__item");
          if (item) item.style.display = "none";
        });
    }

    // Run subito (DOM iniziale)
    hideNoneOptions();

    // Dawn pub-sub: ogni cambio facet ri-renderizza la lista
    if (
      typeof subscribe !== "undefined" &&
      typeof PUB_SUB_EVENTS !== "undefined" &&
      PUB_SUB_EVENTS.facetUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.facetUpdate, hideNoneOptions);
    }

    // Fallback: MutationObserver sui form facet (childList su subtree intercetta i replace AJAX)
    var forms = document.querySelectorAll(
      "#FacetFiltersForm, #FacetFiltersFormMobile",
    );
    if (forms.length) {
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          hideNoneOptions();
        });
      });
      forms.forEach(function (f) {
        mo.observe(f, { childList: true, subtree: true });
      });
    }
  })();

  //VIDEO
  document.querySelectorAll(".off_video").forEach(function (section) {
    const video = section.querySelector("video");
    const btn = section.querySelector(".video-toggle");
    const soundBtn = section.querySelector(".video-sound");
    if (!video || !btn) return;

    let userPaused = false;

    function syncSound() {
      if (!soundBtn) return;
      soundBtn.classList.toggle("is-unmuted", !video.muted);
      soundBtn.setAttribute("aria-pressed", String(!video.muted));
    }

    function doPlay() {
      video
        .play()
        .then(function () {
          btn.classList.add("is-playing");
        })
        .catch(function () {
          // Il browser blocca l'autoplay con audio: ricado su muted invece di
          // lasciare il video fermo. Succede al rientro in viewport dopo un unmute.
          if (video.muted) return;
          video.muted = true;
          syncSound();
          video
            .play()
            .then(function () {
              btn.classList.add("is-playing");
            })
            .catch(function () {});
        });
    }

    function doPause() {
      video.pause();
      btn.classList.remove("is-playing");
    }

    btn.addEventListener("click", function () {
      if (video.paused) {
        userPaused = false;
        doPlay();
      } else {
        userPaused = true;
        doPause();
      }
    });

    // Audio: l'unmute deve partire da un gesto utente, quindi solo da qui.
    if (soundBtn) {
      soundBtn.addEventListener("click", function () {
        video.muted = !video.muted;
        syncSound();
        // Alzare il volume su un video in pausa non farebbe nulla: lo riavvio.
        if (!video.muted && video.paused) {
          userPaused = false;
          doPlay();
        }
      });
      syncSound();
    }

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!userPaused) doPlay();
          } else {
            doPause();
          }
        });
      },
      { threshold: 0.25 },
    ).observe(section);
  });

  //BOUTIQUE
  const btnOpenOption = document.querySelector("#toggle-bttn");
  if (btnOpenOption) {
    btnOpenOption.click();
  }
});

//HEADER
document.addEventListener("DOMContentLoaded", () => {
  const headerWrapper = document.querySelector(
    ".header-wrapper.site-header-overlay",
  );
  if (!headerWrapper) return;

  const toggleHeaderState = () => {
    if (window.scrollY > 10) {
      headerWrapper.classList.add("is-scrolled");
    } else {
      headerWrapper.classList.remove("is-scrolled");
    }
  };

  toggleHeaderState();
  window.addEventListener("scroll", toggleHeaderState, { passive: true });
});

/* =========================================================
   NEWSLETTER MAILCHIMP (footer)
   ---------------------------------------------------------
   Perché esiste questo modulo:
   1) Evitare qualsiasi redirect sulla pagina di Mailchimp
      (né in caso di successo, né in caso di errore).
   2) Validare i campi con regex nostri e mostrare messaggi
      tradotti (IT/EN) gestiti dal tema via data-attribute.
   3) Comunicare con Mailchimp via JSONP (endpoint
      /subscribe/post-json) così la risposta torna in JSON
      e non serve un submit HTML con redirect.

   Il wrapper .form_mailchimp_newsletter espone:
   - data-endpoint:            URL JSONP di Mailchimp
   - data-msg-error-*:         messaggi di errore tradotti
   - data-msg-success:         messaggio di successo tradotto

   L'action del form è "#" di proposito: senza JS il form
   non parte (nessun fallback verso la thankyou Mailchimp).
   ========================================================= */
document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".form_mailchimp_newsletter");
  if (!wrapper) return;

  const form = wrapper.querySelector("form");
  const endpoint = wrapper.dataset.endpoint;
  if (!form || !endpoint) return;

  // --- Riferimenti campi ---
  const fFname = form.querySelector("#mce-FNAME");
  const fLname = form.querySelector("#mce-LNAME");
  const fEmail = form.querySelector("#mce-EMAIL");
  const fConsent = form.querySelector("#mce-gdpr-consent");
  const submitBtn = form.querySelector("#mc-embedded-subscribe");

  // --- Slot messaggi globali ---
  const respOk = form.querySelector("#mce-success-response");
  const respKo = form.querySelector("#mce-error-response");

  // --- Messaggi tradotti (da data-attr Liquid) ---
  const msg = {
    fname: wrapper.dataset.msgErrorFname,
    fnameRequired: wrapper.dataset.msgErrorFnameRequired,
    lname: wrapper.dataset.msgErrorLname,
    emailRequired: wrapper.dataset.msgErrorEmailRequired,
    emailInvalid: wrapper.dataset.msgErrorEmailInvalid,
    consent: wrapper.dataset.msgErrorConsent,
    already: wrapper.dataset.msgErrorAlready,
    generic: wrapper.dataset.msgErrorGeneric,
    success: wrapper.dataset.msgSuccess,
  };

  // --- Regex validazione ---
  // Email: permissivo ma blocca i casi tipici (no spazi, TLD 2+ char).
  const RE_EMAIL = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  // Nome / Cognome: lettere (anche accentate), spazi, apostrofo, trattino. 2-50 char.
  const RE_NAME = /^[A-Za-zÀ-ÖØ-öø-ÿ' \-]{2,50}$/;

  /* ---------------------------------------------------------
     UI helpers
     --------------------------------------------------------- */

  // Mostra errore inline accanto al campo + classe .has-error
  const setFieldError = (inputEl, key, text) => {
    if (inputEl) inputEl.classList.add("has-error");
    const slot = form.querySelector(`.mc-field-error[data-error-for="${key}"]`);
    if (slot) slot.textContent = text || "";
  };

  // Pulisce tutti gli errori inline e i messaggi globali
  const clearAllErrors = () => {
    form
      .querySelectorAll(".has-error")
      .forEach((el) => el.classList.remove("has-error"));
    form
      .querySelectorAll(".mc-field-error")
      .forEach((el) => (el.textContent = ""));
    hideGlobalMessage(respOk);
    hideGlobalMessage(respKo);
  };

  const showGlobalMessage = (el, text) => {
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
  };

  const hideGlobalMessage = (el) => {
    if (!el) return;
    el.textContent = "";
    el.hidden = true;
  };

  /* ---------------------------------------------------------
     Validazione lato client
     Ritorna true se tutto valido, altrimenti popola gli errori
     --------------------------------------------------------- */
  const validate = () => {
    let ok = true;

    // FNAME: obbligatorio (l'audience Mailchimp lo richiede) + regex
    const vFname = (fFname?.value || "").trim();
    if (!vFname) {
      setFieldError(fFname, "FNAME", msg.fnameRequired);
      ok = false;
    } else if (!RE_NAME.test(vFname)) {
      setFieldError(fFname, "FNAME", msg.fname);
      ok = false;
    }

    // LNAME: opzionale; se compilato deve essere valido
    const vLname = (fLname?.value || "").trim();
    if (vLname && !RE_NAME.test(vLname)) {
      setFieldError(fLname, "LNAME", msg.lname);
      ok = false;
    }

    // EMAIL: obbligatoria + regex
    const vEmail = (fEmail?.value || "").trim();
    if (!vEmail) {
      setFieldError(fEmail, "EMAIL", msg.emailRequired);
      ok = false;
    } else if (!RE_EMAIL.test(vEmail)) {
      setFieldError(fEmail, "EMAIL", msg.emailInvalid);
      ok = false;
    }

    // CONSENT: obbligatorio
    if (!fConsent || !fConsent.checked) {
      setFieldError(null, "CONSENT", msg.consent);
      ok = false;
    }

    return ok;
  };

  /* ---------------------------------------------------------
     Chiamata JSONP a Mailchimp
     Mailchimp risponde con `{ result: 'success'|'error', msg }`
     incapsulato in un callback JS (JSONP). Iniettiamo uno
     <script> con URL che termina con &c=<nomeCallback>.
     --------------------------------------------------------- */
  const mailchimpJsonp = (params) =>
    new Promise((resolve, reject) => {
      // Nome callback globale univoco
      const cbName = `mcCb_${Date.now()}_${Math.floor(Math.random() * 1e6)}`;

      // L'endpoint dev'essere post-json (impostato via Liquid).
      // Aggiungiamo i params come querystring + &c=<callback>.
      const url = `${endpoint}&${params.toString()}&c=${cbName}`;

      const script = document.createElement("script");
      script.src = url;
      script.async = true;

      // Timeout di sicurezza: se entro 10s non risponde, rigettiamo.
      const timeoutId = setTimeout(() => {
        cleanup();
        reject(new Error("timeout"));
      }, 10000);

      const cleanup = () => {
        clearTimeout(timeoutId);
        delete window[cbName];
        if (script.parentNode) script.parentNode.removeChild(script);
      };

      window[cbName] = (data) => {
        cleanup();
        resolve(data);
      };

      script.onerror = () => {
        cleanup();
        reject(new Error("network"));
      };

      document.body.appendChild(script);
    });

  /* ---------------------------------------------------------
     Mapping risposta Mailchimp → messaggio nostro
     Mailchimp ritorna `msg` in inglese con pattern noti:
     - "is already subscribed"       → già iscritto
     - altri                         → generico
     --------------------------------------------------------- */
  const mapMailchimpError = (mcMsg = "") => {
    const m = String(mcMsg).toLowerCase();
    if (m.includes("already subscribed")) return msg.already;
    return msg.generic;
  };

  /* ---------------------------------------------------------
     Submit handler
     --------------------------------------------------------- */
  form.addEventListener("submit", async (e) => {
    e.preventDefault(); // blocca SEMPRE la submit nativa → zero redirect
    clearAllErrors();

    if (!validate()) return;

    // Costruzione payload per Mailchimp (tutti i campi del form, solo non vuoti)
    const params = new URLSearchParams();
    const formData = new FormData(form);
    for (const [key, value] of formData.entries()) {
      if (value !== "") params.append(key, value);
    }

    // Disabilita bottone durante la richiesta
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add("is-loading");
    }

    try {
      const data = await mailchimpJsonp(params);
      if (data && data.result === "success") {
        showGlobalMessage(respOk, msg.success);
        form.reset();
      } else {
        showGlobalMessage(respKo, mapMailchimpError(data && data.msg));
      }
    } catch (err) {
      // Errori di rete / timeout / JSONP bloccato
      showGlobalMessage(respKo, msg.generic);
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove("is-loading");
      }
    }
  });

  // Pulizia errori quando l'utente inizia a correggere un campo
  [fFname, fLname, fEmail].forEach((input) => {
    if (!input) return;
    input.addEventListener("input", () => {
      input.classList.remove("has-error");
      const key = input.getAttribute("name");
      const slot = form.querySelector(
        `.mc-field-error[data-error-for="${key}"]`,
      );
      if (slot) slot.textContent = "";
    });
  });
  if (fConsent) {
    fConsent.addEventListener("change", () => {
      const slot = form.querySelector(
        '.mc-field-error[data-error-for="CONSENT"]',
      );
      if (slot) slot.textContent = "";
    });
  }
});

// whishlist
function initWishlistButtons() {
  if (document.querySelector(".wishlist-toggle:not(.accesso)")) {
    document
      .querySelectorAll(".wishlist-toggle:not(.accesso)")
      .forEach(function (btn) {
        if (btn.dataset.wishlistBound) return; // evita doppio binding
        btn.dataset.wishlistBound = "true";

        btn.addEventListener("click", async function () {
          // console.log("CLICCATO", btn);

          const productId = btn.dataset.productId;
          const isActive = btn.classList.contains("is-active");
          const action = isActive ? "remove" : "add";
          const loader = btn.querySelector(".loading__spinner");

          btn.disabled = true;
          btn.classList.add("is-loading");
          setTimeout(function () {
            loader.classList.remove("hidden");
          }, 200);

          try {
            const response = await fetch("/apps/wishlist", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ action: action, product_id: productId }),
            });

            const data = await response.json();
            console.log("Risposta wishlist:", data);

            if (data.error) {
              console.error("Wishlist error:", data.error);
              alert("Errore: " + data.error);
            } else {
              btn.classList.toggle("is-active");
            }
          } catch (err) {
            console.error("Wishlist request failed:", err);
          } finally {
            btn.disabled = false;
            btn.classList.remove("is-loading");
            loader.classList.add("hidden");
          }
        });
      });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initWishlistButtons);
} else {
  initWishlistButtons();
}

function formJapanRequests() {
  function setChiusa(chiusa) {
    document.querySelectorAll(".form_japan_popup").forEach(function (popup) {
      popup.classList.toggle("chiuso", chiusa);
    });
  }

  document.querySelectorAll(".form_japan_btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      setChiusa(false);
    });
  });

  document.querySelectorAll(".close_form").forEach(function (btn) {
    btn.addEventListener("click", function () {
      setChiusa(true);
    });
  });
}
if (document.querySelector(".form_japan_popup")) {
  formJapanRequests();
}
